import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UploadFile } from 'antd';

interface IImageBase64 {
    name: string;
    base_64: string;
}
interface IChatInputState {
    inputValue: string;
    selectedTags: string[];
    fileContentType: string;
    imageBase64List: IImageBase64[];
    filePath: string;
    fileList: UploadFile[];
    inSessionUploadAvailable: boolean;
}

const initialState: IChatInputState = {
    inputValue: "",
    selectedTags: [],
    fileContentType: "",
    imageBase64List: [],
    filePath: "",
    fileList: [],
    inSessionUploadAvailable: true
  };

const chatInputSlice = createSlice({
name: 'chat-input',
initialState,
reducers: {
    setInputValue(state, action) {
        state.inputValue = action.payload;
    },
    setSelectedTags(state, action) {
        if (!state.selectedTags.includes(action.payload)) {
            state.selectedTags.push(action.payload);
        }
    },
    setFileContentType(state, action) {
        state.fileContentType = action.payload;
    },
    setImageBase64List(state, action: PayloadAction<IImageBase64[]>) {
        state.imageBase64List.push(...action.payload);
    },
    removeImageBase64(state, action) {
        state.imageBase64List = state.imageBase64List.filter((item) => item.name !== action.payload.name);
      },
    clearImageBase64List(state) {
        state.imageBase64List = [];
    },
    setFilePath(state, action) {
        state.filePath = action.payload;
    },
    setFileList(state, action) {
        state.fileList = action.payload;
    },
    setInSessionUploadAvailable(state, action) {
        state.inSessionUploadAvailable = action.payload;
    },
    resetChatInputState() {
        return initialState;;
    }
}
});

export const { 
setInputValue,
setSelectedTags,
setFileContentType,
setImageBase64List,
removeImageBase64,
clearImageBase64List,
setFilePath,
setFileList,
setInSessionUploadAvailable,
resetChatInputState } = chatInputSlice.actions;
export default chatInputSlice.reducer;